// Tour photos are stored in S3 one-per-country (not per-tour — too many tours to keep photos
// current for each): bucket "avion-dev", folder "bus/{English country name}/cover.png",
// "cover-2.png", "cover-3.png" for the details-page gallery. Callers fall back to a
// placeholder on 404 (see TourCard / TourGallery).
const COUNTRY_EN = {
  Latvija: "Latvia",
  Lietuva: "Lithuania",
  Igaunija: "Estonia",
  Polija: "Poland",
  Vācija: "Germany",
  Francija: "France",
  Itālija: "Italy",
  Spānija: "Spain",
  Portugāle: "Portugal",
  Šveice: "Switzerland",
  Austrija: "Austria",
  Čehija: "Czechia",
  Slovākija: "Slovakia",
  Ungārija: "Hungary",
  Horvātija: "Croatia",
  Slovēnija: "Slovenia",
  Grieķija: "Greece",
  Nīderlande: "Netherlands",
  Holande: "Netherlands",
  Beļģija: "Belgium",
  Luksemburga: "Luxembourg",
  Dānija: "Denmark",
  Zviedrija: "Sweden",
  Norvēģija: "Norway",
  Somija: "Finland",
  Lielbritānija: "United Kingdom",
  Anglija: "England",
  Īrija: "Ireland",
  Islande: "Iceland",
  Malta: "Malta",
  Kipra: "Cyprus",
  Bulgārija: "Bulgaria",
  Rumānija: "Romania",
  Melnkalne: "Montenegro",
  Serbija: "Serbia",
  "Bosnija un Hercegovina": "Bosnia and Herzegovina",
  Ziemeļmaķedonija: "North Macedonia",
  Albānija: "Albania",
  Turcija: "Turkey",
  Krievija: "Russia",
  Ukraina: "Ukraine",
  Baltkrievija: "Belarus",
  Moldova: "Moldova",
  Lihtenšteina: "Liechtenstein",
  Monako: "Monaco",
  "San Marino": "San Marino",
  Andora: "Andorra",
  Vatikāns: "Vatican",
};

function buildUrl(folder, file) {
  return (
    `https://${window.SERVER_DATA.REACT_APP_BUCKET_NAME}.` +
    `${window.SERVER_DATA.REACT_APP_BUCKET_PATH}/bus/${folder}/${file}`
  );
}

export function getCountryImageUrl(country) {
  const folder = COUNTRY_EN[country];
  return folder ? buildUrl(folder, "cover.png") : null;
}

export function getCountryGalleryUrls(country) {
  const folder = COUNTRY_EN[country];
  if (!folder) return [];
  return ["cover.png", "cover-2.png", "cover-3.png"].map((file) => buildUrl(folder, file));
}

// Used to vary the cover photo per tour (picking cover-2.png .. cover-5.png by a hash of the
// tour code) so tours to the same country didn't all look identical — but most countries only
// ever got cover.png uploaded, so that picked a 404 for the majority of tours, showing the
// broken-image placeholder instead of a photo. Always using cover.png is less varied but
// actually loads.
export function getCountryCoverUrl(country) {
  return getCountryImageUrl(country);
}
